import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button, TextField, Grid, Backdrop, Fade } from '@mui/material';
import { toast } from 'react-toastify';
import { otp_resent, otp_verification } from '../asiosConfig';
import OTP from "../images/OTP_1.png";
import bgImg from "../images/otp_modal_bg.png";

import { logEvent } from 'firebase/analytics';
import { analytics } from '../services/firebaseConfig';

const OtpVerification = ({ open, onClose, phone, token, onSuccess, onError }) => {
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [timer, setTimer] = useState(60); // countdown timer

    const [otpError, setOtpError] = useState("");



    // useEffect(() => {
    //     let interval = null;
    //     if (open) {
    //         setTimer(60); // reset timer when modal opens
    //         interval = setInterval(() => {
    //             setTimer((prev) => {
    //                 if (prev === 1) {
    //                     clearInterval(interval);
    //                     return 0;
    //                 }
    //                 return prev - 1;
    //             });
    //         }, 1000);
    //     }
    //     return () => clearInterval(interval); // cleanup on modal close
    // }, [open]);

    useEffect(() => {
    let interval = null;

    if (open && timer > 0) {
        interval = setInterval(() => {
            setTimer((prev) => prev - 1);
        }, 1000);
    }

    return () => clearInterval(interval);
}, [open, timer]);


    // const handleChange = (e, index) => {
    //     const value = e.target.value;
    //     if (!/^\d?$/.test(value)) return;

    //     const newOtp = [...otp];
    //     newOtp[index] = value;
    //     setOtp(newOtp);

    //     // Auto focus to next field
    //     if (value && index < 5) {
    //         const nextInput = document.getElementById(`otp-${index + 1}`);
    //         nextInput?.focus();
    //     }
    // };



    const handleChange = (e, index) => {
    setOtpError(""); // clear error on typing

    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput?.focus();
    }
};


    const handleSubmit = async () => {
        const otpValue = otp.join('');

        // if (otpValue.length !== 6) {
        //     toast.error("Please enter a valid 6-digit OTP");
        //     return;
        // }

        if (otpValue.length !== 6) {
            setOtpError("Please enter the complete 6-digit OTP.");
            return;
        } else {
            setOtpError(""); // clear error when valid
        }


       const payload = {
  token: token,               
  otp: otpValue,              
  firebase_token: "",         
};


        try {
            const response = await otp_verification(payload);

            console.log("OTP RAW RESPONSE:", response);

            // ✔ OLD WORKING LOGIC
            const isSuccess =
                response.data?.success === true ||
                response.data?.is_verified === 1;

            if (isSuccess) {
                // Store token in localStorage after successful OTP verification
                console.log("OTP SUCCESS - Response data:", response.data);
                if (response.data.token) {
                    localStorage.setItem("token", response.data.token);
                    console.log("Token stored:", response.data.token);
                } else {
                    console.log("No token in response data");
                }

                logEvent(analytics, "campaign_register", {
                    user_id: response.data.user_id,
                    username: response.data.username,
                    campaign_id: sessionStorage.getItem("campaign_id"),
                    utm_source: sessionStorage.getItem("utm_source"),
                    utm_medium: sessionStorage.getItem("utm_medium"),
                    utm_campaign: sessionStorage.getItem("utm_campaign"),
                });

                // ✔ CLOSE MODAL → GO TO NEXT STEP
                onSuccess();
                return;
            }

            // toast.error(response.data?.message || "Verification failed");
            if (onError) onError(response.data?.message || "Please enter the correct OTP");


        }
        catch (err) {
    if (onError) onError(err.response?.data?.message || "Please enter the correct OTP");

    // ❗ CLEAR OTP INPUTS AFTER WRONG ATTEMPT
    setOtp(Array(6).fill(""));
    document.getElementById("otp-0")?.focus();

    console.log("OTP ERROR RESPONSE:", err.response);
}


        // catch (err) {
        //     toast.error(err.response?.data?.message || "Something went wrong");
        // }
    };



    const handleResendOtp = async () => {
        try {
            const response = await otp_resent({ phone: phone }); // replace with actual resend API
            if (response.status === 200) {
                toast.success('OTP resent successfully');
                setOtp(Array(6).fill(''));
                setTimer(60);
            } else {
                toast.error('Failed to resend OTP');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error resending OTP');
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];

            if (otp[index] === '') {
                if (index > 0) {
                    const prevInput = document.getElementById(`otp-${index - 1}`);
                    prevInput?.focus();
                    newOtp[index - 1] = '';
                    setOtp(newOtp);
                }
            } else {
                newOtp[index] = '';
                setOtp(newOtp);
            }
            e.preventDefault();
        }
    }

    return (
        // <Modal
        //     open={open}
        //     onClose={() => { }}
        //     closeAfterTransition
        //     slots={{ backdrop: Backdrop }}
        //     slotProps={{
        //         backdrop: {
        //             timeout: 500,
        //         },
        //     }}
        // >

        <Modal
            open={open}
            onClose={() => { }}
            closeAfterTransition
            disablePortal={false}
            disableEnforceFocus
            disableAutoFocus
            container={() => document.body}
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: { timeout: 500 }
            }}
        >

            <Fade in={open}>

                <Box
                    sx={{
                        width: { xs: '90%', sm: 400, md: 500 },
                        height: { xs: 'auto', md: 440 },
                        backgroundImage: `url(${bgImg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 5,
                        p: { xs: 3, sm: 4 },
                        mx: 'auto',
                        mt: { xs: '20%', sm: '10%' },
                        boxShadow: 24,
                        textAlign: 'center',
                        position: 'relative',
                    }}
                >
                    <Button
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 20,
                            minWidth: 'unset',
                            padding: 0,
                            color: '#000',
                            fontSize: '3rem',
                            background: 'transparent',
                            '&:hover': { background: 'transparent' },
                        }}
                    >
                        &times;
                    </Button>
                    <Box mb={3}>
                        <Box
                            component="img"
                            src={OTP}
                            alt="OTP"
                            sx={{
                                width: { xs: 80, sm: 100 },
                                height: 'auto',
                                mx: 'auto',
                            }}
                        />
                    </Box>

                    <Typography fontWeight={700} fontFamily="Montserrat" mb={1} fontSize={20}>
                        OTP Verification
                    </Typography>

                    <Typography fontFamily="Montserrat" fontWeight={400} mb={3}>
                        Enter the OTP sent to <span style={{ fontFamily: 'Montserrat', fontWeight: 600 }}>+91 {phone}</span>
                    </Typography>

                    <Grid container spacing={1} justifyContent="center" mb={2}>
                        {otp.map((digit, idx) => (
                            <Grid item xs={2} sm={1.5} key={idx}>
                                <TextField
                                    id={`otp-${idx}`}
                                    fullWidth
                                    inputProps={{
                                        autoComplete: "one-time-code",
                                        maxLength: 1,
                                        inputMode: "numeric",
                                        pattern: "[0-9]*",
                                        maxLength: 6,
                                        style: {
                                            textAlign: 'center',
                                            fontSize: '1.2rem',
                                            color: '#0a0a0aff',
                                            padding: '10px',
                                        },
                                    }}
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            p: '12px 0',
                                        },
                                        '& input': {
                                            fontSize: { xs: '1.2rem', sm: '1.5rem' },
                                        },
                                    }}
                                    type="tel" 
                                    value={digit}
                                    onChange={(e) => handleChange(e, idx)}
                                    onKeyDown={(e) => handleKeyDown(e, idx)} // ✅ Add this
                                />

                            </Grid>
                        ))}
                    </Grid>

                    {otpError && (
                        <Typography
                            fontFamily="Montserrat"
                            fontSize="14px"
                            color="red"
                            mb={2}
                            style={{ marginTop: "-10px" }}
                        >
                            {otpError}
                        </Typography>
                    )}



                    <Typography variant="body2" ontWeight={400} fontFamily="Montserrat" mb={2}>
                        Didn’t receive the OTP?{' '}
                        {timer > 0 ? (
                            <span style={{ color: '#888' }}>Resend in {timer}s</span>
                        ) : (
                            <span
                                style={{ color: '#e75b2d', cursor: 'pointer' }}
                                onClick={handleResendOtp}
                            >
                                Resend OTP
                            </span>
                        )}
                    </Typography>

                    <Button
                        type="button"
                        onClick={handleSubmit}
                        style={{
                            width: 200,
                            height: 50, // adjust to match the img height
                            background: "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.34)), linear-gradient(90deg, #f78c25, #ff3c3c)",
                            border: "none",
                            borderRadius: 30,
                            color: "#fff",
                            fontWeight: "bold",
                            cursor: "pointer",
                            letterSpacing: "2px"

                        }}
                    >
                        Verify
                    </Button>

                </Box>
            </Fade>
        </Modal>

    );
};

export default OtpVerification;




